<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <NavTabs
      :tabs="tabs"
      :activeTab="newActiveTab"
      @sendData="updateData"
    />

    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import { isEmpty } from 'lodash';
import { LOCALES } from '@/locales/i18n';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import Firmware from '@/components/forms/devices/Firmware';
import GeneralInfo from '@/components/forms/devices/GeneralInfo';

export default {
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        NavTabs,
    },
    props: {
        device: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            tabs: [],
            components: [GeneralInfo, Firmware],
            model: {
                type: null,
                model: null,
                description: {},
                firmware: {
                    version: null,
                    description: null,
                    file: null,
                },
            },
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'site',
            'userLang',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
        isLangUsed() {
            return lang => Object.values(this.model.description).findIndex(des => des.lang === lang) >= 0;
        },
        totalDescLength() {
            return Object.keys(this.model.description).length;
        },
        langs() {
            return LOCALES.map(lang => ({
                name: this.$t(`langs.${lang}`),
                key: lang,
                disabled: this.isLangUsed(lang),
            }));
        },
    },
    async created() {
        this.loading = true;
        this.reset();
        await this.getData();
        this.tabs = this.tableHeaders();
        this.loading = false;
    },
    methods: {
        tableHeaders() {
            const headers = this.components.map((component, index) => ({
                index,
                props: { device: this.model },
                name: this.$t(`deviceForm.step${index}.title`),
                component: Vue.component(`tab-${index}`, component),
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        updateData(newData) {
            this.model = { ...this.model, ...newData };
            this.$emit('sendData', this.model);
        },
        reset() {
            this.$store.dispatch('changeActiveTab', 0);
        },
        async getData() {
            if (this.isEdition) {
                this.prepareDeviceTypeOnEdit(this.device);
            } else {
                this.onClickAddRow();
            }
        },
        prepareDeviceTypeOnEdit(deviceType) {
            this.model = { ...this.model, ...deviceType };
            this.prepareDescriptions();
        },
        onClickAddRow() {
            const nonDisabledLang = this.langs.find(lang => !lang.disabled);
            const tempDesc = JSON.parse(JSON.stringify(this.model.description));
            this.model.description = { ...tempDesc, [nonDisabledLang.key]: { lang: nonDisabledLang.key, description: '' } };
        },
        prepareDescriptions() {
            if (!this.model.description || isEmpty(this.model.description)) {
                this.onClickAddRow();
            } else {
                Object.keys(this.model.description).forEach(key => {
                    this.model.description[key] = { lang: key, description: this.model.description[key] };
                });
            }
        },
    },
};
</script>
